import Vue from 'vue'
import VueI18n from 'vue-i18n'
import $local from 'storejs'
import moment from 'moment'
import eleEnLang from 'element-ui/lib/locale/lang/en'
import eleCnLang from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

let lang = $local.get('lang') || 'en-US';

if (lang === 'zh-CN' || lang === 'zh-HK') {
    moment.locale('zh-cn')
    locale.use(eleCnLang)
} else {
    moment.locale('en')
    locale.use(eleEnLang)
}

Vue.use(VueI18n);
export default new VueI18n({
    locale: lang,
    messages: {
        'zh-CN': require('./lang/zh-CN.json'),   // 中文语言包
        'zh-HK': require('./lang/zh-HK.json'),   // 中文语言包
        'en-US': require('./lang/en-US.json')    // 英文语言包
    }
})





// WEBPACK FOOTER //
// ./src/i18n/i18n.js